<template>
    <div id="animateNum" class="numConAnim" :class="[newClass, cyynewClass, gqClass]">
        <!-- 正常数值时 -->
        <p>
            <span>{{ title }}</span>
        </p>
        <div class="numItem" :class="[numBgClass, item === ',' ? numSymClass : '']" :style="item === ',' ? numSymbolStyle : numStyle" v-for="(item, index) in numberArr" :key="index">
            <i-count-up v-if="/^[0-9]+.?[0-9]*/.test(item)" :startVal="startVal" :endVal="item" :decimals="decimals" :duration="duration" :options="options">{{ item }}</i-count-up>
            <!-- <span v-else style="padding-top: 0px">{{item}}</span> -->
        </div>
        <!-- <template v-if="decimalArr.length > 1 && decimal">
            <div
                class="numItem"
                :class="[numBgClass, actClass, decSymClass, decitem === '.' ? decSymClass : '']"
                :style="decitem === '.' ? decSymbolStyle : decimalnumStyle"
                v-for="(decitem, devindex) in decimalArr"
                :key="101 + devindex"
            >
                <i-count-up v-if="/^[0-9]+.?[0-9]*/.test(decitem)" :startVal="startVal" :endVal="decitem" :decimals="decimals" :duration="duration" :options="options">{{ decitem }}</i-count-up>
                <span v-else>{{ decitem }}</span>
            </div>
        </template> -->
    </div>
</template>
<script>
/* eslint-disable */
import ICountUp from 'vue-countup-v2';
export default {
    props: {
        title: {
            type: String,
            default: '儿童总数'
        },
        value: {
            type: [String, Number],
            default: () => {
                return '';
            }
        },
        numStyle: {
            type: String,
            default: () => {
                return '';
            }
        },
        decimalnumStyle: {
            type: String,
            default: () => {
                return '';
            }
        },
        decimal: {
            // 是否显示小数
            type: Boolean,
            default: () => {
                return true;
            }
        },
        actClass: {
            type: String,
            default: ''
        },
        newClass: {
            type: String,
            default: ''
        },
        cyynewClass: {
            type: String,
            default: ''
        },
        numBgClass: {
            type: String,
            default: ''
        },
        numSymbolStyle: {
            type: String,
            default: ''
        },
        decSymbolStyle: {
            type: String,
            default: ''
        },
        numSymClass: {
            type: String,
            default: ''
        },
        decSymClass: {
            type: String,
            default: ''
        },
        gqClass: {
            type: String,
            default: ''
        }
    },
    computed: {
        isNumber(res) {
            var re = /^[0-9]+.?[0-9]*/;
            if (!re.test(Number(res))) {
                return false;
            } else {
                return true;
            }
        }
    },
    components: {
        ICountUp
    },
    data() {
        return {
            zeroArr: ['.', '0', '0'],
            isZero: true,
            startVal: 0,
            decimals: 0,
            duration: 8.5,
            options: {
                useEasing: true,
                useGrouping: true,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: ''
            },
            number: '',
            numberArr: [],
            decimalArr: [] // 小数
        };
    },
    watch: {
        value(res) {
            if (Number(res) === 0) {
                this.isZero = true;
                this.setNum(res);
            } else {
                this.isZero = false;
                this.setNum(res);
            }
        }
    },
    methods: {
        setNum(res) {
            // 传过来数字格式
            const num = String(res.toFixed(2)).split('.'); // 把小数提取出来
            const number = num[0].toString().split('');
            const numLength = number.length;
            const numberArr = [];
            if (numLength == 0) {
                this.$set(this, 'numberArr', [0]);
                return;
            }
            for (let i = 0; i < numLength; i++) {
                const item = number[i];
                var re = /^[0-9]+.?[0-9]*/;
                if (re.test(Number(item))) {
                    numberArr.push(Number(item));
                } else {
                    numberArr.push(item);
                }
            }
            this.$set(this, 'numberArr', numberArr);
        }
    }
};
</script>

<style scoped lang="scss">
@mixin block {
    width: 40px;
    height: 76px;
    //   line-height: 76px;
}
@mixin decBlock {
    width: 30px;
    height: 54px;
}
.numConAnim {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;
    position: relative;
    z-index: 9999;
    padding-right: 70px;
    .numItem {
        // display: flex;
        margin-left: 5px;
        align-items: center;
        justify-content: center;
        color: #f0bd26;
        font-size: 57px;
        // background: rgba(0, 105, 83, 0.5);
        span {
            height: 100%;
            width: 100%;
            margin-top: 15px;
            margin-top: 10px;
            display: inline-block;
            text-align: center;
            font-family: DIN Condensed Bold;
        }
    }
    .numItemBlack {
        @include block;
        display: flex;
        margin-left: 5px;
        align-items: center;
        justify-content: center;
        color: #f0bd26;
        font-size: 57px;
        line-height: 114px;
        // background: rgba(0, 0, 0, 0.5);
        span {
            padding-top: 12px;
            height: 100%;
            width: 100%;
            margin-top: 0 !important;
            display: block;
            //   text-align: center;
            font-family: DIN Condensed Bold;
        }
    }
    .numItemBlack .decimal {
        span {
            margin-top: 12px !important;
        }
    }
    .decimalnum {
        @include decBlock;
        display: flex;
        margin-left: 5px;
        align-items: center;
        justify-content: center;
        color: #f0bd26;
        font-size: 40px;
        background: rgba(0, 105, 83, 0.5);
        span {
            height: 100%;
            width: 100%;
            margin-top: 10px !important;
            display: inline-block;
            text-align: center;
            font-family: DIN Condensed Bold;
        }
    }
    :nth-of-type(1) {
        margin-left: 0;
    }
    .decimal {
        width: 27px !important;
        height: 57px !important;
        font-size: 44px !important;
        line-height: 57px;
        span {
            padding-top: 0px;
        }
    }
}
.whaleClass {
    padding-top: 2px;
}
.whaleClass::after {
    content: '吨';
    display: block;
    font-size: 33px;
    font-family: DIN Condensed Bold;
    margin-left: 5px;
    margin-right: -60px;
    font-weight: bold;
    background: #28e770;
    width: 54px;
    height: 44px;
    color: #000000;
    text-align: center;
    background: linear-gradient(-135deg, transparent 8px, #28e770 0) top right;
}
.whaleClass > p {
    color: #28e770 !important;
}
.newclass::after {
    display: block;
    font-size: 33px;
    font-family: DIN Condensed Bold;
    margin-left: 5px;
    margin-right: -60px;
    font-weight: bold;
    background: #ffc21c;
    width: 82px;
    height: 44px;
    color: #000000;
    text-align: center;
    background: linear-gradient(-135deg, transparent 8px, #ffc21c 0) top right;
}

.cyynewClass::after {
    content: '万美元';
}
.firstCls {
    background: #ffc21c;
    width: 65px;
    height: 98px;
    line-height: 98px;
    span {
        color: #000000;
        font-weight: bold;
        font-size: 91px;
    }
}
.secondCls {
    background: #28e770 !important;
    width: 65px;
    height: 98px;
    span {
        color: #000000;
        font-weight: bold;
        font-size: 91px;
    }
}
.numConAnim > .num-class {
    margin-top: 0;
    margin-left: 0;
    background: none;
    width: 20px;
    height: 60px;
    font-weight: bold;
    font-size: 56px;
    > span {
        margin-top: 0;
    }
}
.numConAnim > .num-class.num-sym-class {
    width: 10px;
}

.numConAnim > .dec-class {
    width: 10px;
    font-size: 28px;
    > span {
        display: flex;
        justify-content: center;
        align-items: flex-end;
    }
}
.numConAnim > .dec-class.dec-sym-class {
    width: 7px;
    margin-right: 1px;
}
.gqClass {
    margin-top: -15px;
}
.firstNum,
.secondNum {
    position: relative;
    p {
        // position: absolute;
        margin-bottom: -5px;
        color: #ffc21c;
        font-size: 30px;
        font-weight: bold;
        left: 610px;
        margin-right: 10px;
        // bottom: 32px;
        span {
            display: block;
            text-align: right;
            line-height: 1.2;
        }
    }
}
.dot {
    width: 40px;
    height: 61px;
    span {
        display: block !important;
        font-size: 50px;
    }
}
</style>
